import { Component, Input } from '@angular/core';
import { ExpandAnimation } from '../../utility/animations';

@Component({
    selector: 'expandable-block',
    templateUrl: './expandable-block.html',
    styleUrls: ['./expandable-block.scss'],
    animations: [ExpandAnimation]
})
export class ExpandableBlockComponent {
    constructor() {}

    // Bindings
    @Input() title: string;

    // Properties
    animationState: string = 'collapsed';


    //----------------------------------
    // Lifecycle Hooks
    //----------------------------------

    ngOnInit() {

    }


    //----------------------------------
    // Public Methods
    //----------------------------------
}


// WEBPACK FOOTER //
// ./src/app/partials/expandable-block/expandable-block.component.ts